import { resImageUpload, resVideoUpload } from '../../../api/common'
import {WZ} from '../../../utils/wz.v2';
import {HOST_WEB} from '../../../utils/xp.v1'
import {
    jiandingGetTabs,
    jiandingGetOrders,
    jiandingOrderDetail,
    jiandingGetAppraisers,
    jiandingMakeOrder,
    jiandingEvaluate,
    jiandingOrderCancel,
    jiandingOrderStop,
    jiandingStepDo,
    jiandingAppraiserInfo,
    jiandingGetAppraiser,
    jiandingConfig,
    jiandingTake,
    jiandingTakeMoney,
    jiandingMoneyLog,
    jiandingCert
} from '../../../api/jianding'

export default {
    async saveImage(_, { formId, imgData }) {
        const form = document.getElementById(formId)
        //let fileFormat = /\.(\w+)$/.test(fileName) ? RegExp.$1 : 'jpg';
        if (form) {
            if (/^data:image\/(\w+);base64,/.test(imgData)) {
                //fileFormat = RegExp.$1;
                //imgData = imgData.replace(/^data:image\/(\w+);base64,/, '')
            }
            // console.log(imgData)
            //form.fileFormat.value = fileFormat;
            //form._content.value = imgData;
            const R = await resImageUpload(formId);
            //const { imgRid, imgUrl } = R
            //commit('imgUpdate', { imgKey, imgRid, imgUrl })

            return R
        } else {
            throw new Error(`no form ${formId}`)
        }
    },

    async saveVideo(_, {formId}){
        const form = document.getElementById(formId);
        if(form){
            const R = await resVideoUpload(formId);
            return R
        } else {
            throw new Error(`no form ${formId}`)
        }
    },

    //鉴定分类
    async loadTabs({commit}, query){
        const R = await jiandingGetTabs(query);
        let list = R.list || [];
        commit('setTabs', {list});
        return R
    },

    //鉴定时选择鉴定师列表
    async loadAppraisers({commit}, query){
        const R = await jiandingGetAppraisers(query);
        let {myAppraiser, appraisers} = R;
        commit('setAppraisers', {myAppraiser, appraisers});
        return R
    },
    //鉴定师列表
    async loadAppraisersList({commit}, query){
        const R = await jiandingGetAppraisers(query);
        let {myAppraiser, appraisers, page} = R;
        commit('setAppraisersList', {
            myAppraiser,
            appraisers,
            page,
            query
        });
        return R
    },

    async loadOrders({commit}, query){
        const R = await jiandingGetOrders(query);
        let list = R.list;
        commit('setOrders', {list});
        return R
    },

    async loadOrderDetail({commit}, query){
        const R = await jiandingOrderDetail(query);
        let data = Object.assign({}, R);
        commit('setOrderDetail', data);
        return R
    },

    async makeOrder({dispatch}, query){
        const R = await jiandingMakeOrder(query);
        let {orderId, orderSn, orderScene,orderAmount} = R;
        if (orderId && orderSn && orderScene) {
            dispatch('goCash',{orderId, orderSn, orderScene,orderAmount})
        }
        //return R
    },
    // 前往收银台
    async goCash(context, o) {
        let query = {
            orderScene: o.orderScene,
            orderId: o.orderId,
            orderSn: o.orderSn,
            orderAmount: o.orderAmount,
            delay: 3, // 支付成功延时 3秒 再跳转
            redirectUrl: `https://${HOST_WEB}/jianding/my/order`
        };
        if(o.redirectUrl) query.redirectUrl = o.redirectUrl;
        if(query.orderScene && query.orderId && query.orderSn && query.orderAmount){
            await WZ.go('cash', query)
        }

    },

    //评价
    async goEvaluate(state, query){
        const R = await jiandingEvaluate(query);
        return R
    },

    //取消订单
    async orderCancel(state, query){
        const R = await jiandingOrderCancel(query);
        return R
    },

    //暂停鉴定
    async orderStop(state, query){
        const R = await jiandingOrderStop(query);
        return R
    },

    //开始鉴定
    async startAppraisal(state, query){
        const R = await jiandingStepDo(query);
        return R
    },

    //首页商品展示
    async finishList({commit}, query){
        const R = await jiandingGetOrders(query);
        let list = R.list;
        let page = R.page || 1;
        commit('setFinishOrders', {list,page});
        return R
    },

    //鉴定师商品展示
    async loadAuthenticatedList({commit}, query){
        const R = await jiandingGetOrders(query);
        let list = R.list;
        commit('setAuthenticated', {list});
        return R
    },

    //鉴定师统计
    async loadAppraiserInfo({commit}, query){
        const R = await jiandingAppraiserInfo(query);
        let {appraiser, userTotal, appraisersTotal} = R;
        commit('setAppraiserInfo', {appraiser, userTotal, appraisersTotal});
        return R
    },

    //鉴定师统计
    async loadDetailAppraiser({commit}, query){
        const R = await jiandingGetAppraiser(query);
        let {appraiser} = R;
        commit('setDetailAppraiser', {appraiser});
        return R
    },

    //年代配置信息
    async loadConfig({commit}, query){
        const R = await jiandingConfig(query);
        let {periods, trend, service, speed, isReal} = R;
        commit('setJdConfig', {periods, trend, service, speed, isReal});
        return R
    },

    //提现列表
    async loadTake({commit}, query){
        const R = await jiandingTake(query);
        let {total , totalMoney , money , list} = R;
        commit('setTake', {total , totalMoney , money , list});
        return R
    },

    //申请提现
    async takeMoney(_, query){
        const R = await jiandingTakeMoney(query);
        return R
    },

    //申请提现
    async LoadMoneyLog({commit}, query){
        const R = await jiandingMoneyLog(query);
        let { list, page } = R;
        commit('setMoneyLog', {list, page});
        return R
    },

    //鉴定证书
    async loadCert(_, query){
        const R = await jiandingCert(query);
        return R
    }
}